import type { Fallacy } from "./types";
import { createStory } from "./types";

export const weaselWords: Fallacy = {
    id: "weasel-words",
    name: "Weasel Words",
    emoji: "🦊",
    category: "Jebakan Bahasa",
    description:
      "Menggunakan **kata-kata samar** yang terdengar meyakinkan tapi **tidak bisa diverifikasi**. \"Beberapa ahli mengatakan...\"",
    tldr: "\"Banyak yang bilang...\" — siapa? Mana sumbernya? Itu weasel words.",
    detail:
      "Weasel Words adalah penggunaan bahasa yang **sengaja dibuat samar** agar terdengar kredibel tanpa memberikan informasi yang bisa diverifikasi. Seperti musang yang mengisap isi telur tanpa merusak cangkangnya — weasel words **'mengosongkan' klaim dari substansinya**.\n\nFrasa yang sering muncul:\n• \"Banyak ahli berpendapat...\" — ahli siapa?\n• \"Menurut penelitian...\" — penelitian mana?\n• \"Sudah terbukti bahwa...\" — buktinya apa?\n• \"Masyarakat menilai...\" — survei dari mana?\n\nCara mengenali: Setiap kali ada klaim tanpa sumber spesifik, tanyakan: **Siapa? Kapan? Di mana? Berapa?** Kalau tidak bisa dijawab, kemungkinan besar itu weasel words.",
    story: createStory("Weasel Words", "🦊", {
      hook: {
        title: "\"Banyak ahli bilang...\"",
        body: "Ahli siapa? Banyak itu berapa? Penelitian mana? Kok gak ada sumbernya?",
      },
      convo: {
        claim: "Suplemen ini udah **direkomendasikan banyak pakar kesehatan** dan sudah terbukti secara klinis. Banyak yang udah buktiin sendiri hasilnya.",
        response: "Pakar siapa? Klinis di mana? **Gak ada satu pun sumber spesifik.**",
      },
      reveal: {
        body: "Kata-kata yang **sengaja dibuat samar** biar kedengeran kredibel. Kayak musang ngisap isi telur tanpa rusak cangkangnya — **klaimnya dikosongkan dari substansi**.",
      },
      insight: {
        title: "Cara ngeceknya gampang:",
        body: "Tanya aja 4 hal: **Siapa? Kapan? Di mana? Berapa?** Kalau gak bisa dijawab, klaimnya kemungkinan besar kosong.",
      },
      engagement: {
        title: "Paling sering denger weasel words di mana?",
        body: "Iklan suplemen atau pidato politisi? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["appeal-to-authority", "framing-effect", "cherry-picking"],
  };
